import { createFileRoute } from "@tanstack/react-router";

import {
  Disclosure,
  DisclosureHeader,
  DisclosurePanel,
} from "@/components/base/disclosure";
import { DismissibleAlert } from "@/components/base/dismissible-alert";
import { Link } from "@/components/base/link";
import { title } from "@/components/base/primitives";
import { ForgotPasswordEmailForm } from "@/components/users/forgot-password-email-form";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/account/forgot-password/email")({
  head: () => ({
    meta: [{ title: "Forgot Password" }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DefaultLayout>
      <div className="mx-auto flex max-w-xl flex-col space-y-6 text-center">
        <h1 className={title({ size: "lg" })}>Forgot your password?</h1>

        <p className="mx-auto max-w-md">
          Fill out the form below and we'll send you a link to reset your
          password.
        </p>
      </div>

      <div className="mx-auto flex w-full max-w-sm flex-col space-y-4 px-3">
        <DismissibleAlert
          dismissKey="forgot-password-email-info"
          color="info"
          title="Returning User?"
          description={
            <div>
              <p>
                If you had an account on our previous system, use this form to
                set a new password. Enter the email address associated with your
                account and check your inbox for a reset link.
              </p>

              <Disclosure card={false} className="text-inherit">
                <DisclosureHeader
                  card={false}
                  size="sm"
                  className="text-inherit"
                >
                  Not getting an email?
                </DisclosureHeader>
                <DisclosurePanel card={false}>
                  <div>
                    <ul className="list-inside list-disc space-y-1 text-inherit">
                      <li>Check your spam or junk folder</li>
                      <li>
                        Verify you're using the same email address from your
                        original account
                      </li>
                      <li>Wait a few minutes and try again</li>
                      <li>
                        Contact{" "}
                        <a href="mailto:info@cbva.com" className="underline">
                          info@cbva.com
                        </a>{" "}
                        for assistance
                      </li>
                    </ul>
                    <p className="mt-4">
                      <span className="font-semibold">Note:</span> some email
                      providers such as Yahoo might take up to 10 minutes or
                      more to receive our emails.
                    </p>
                  </div>
                </DisclosurePanel>
              </Disclosure>
            </div>
          }
        />
      </div>

      <ForgotPasswordEmailForm className="mx-auto w-full max-w-sm rounded-lg bg-white p-8" />

      <p className="mt-4 text-center text-gray-600">
        <Link to="/account/forgot-password/phone">
          Receive a text message instead
        </Link>
      </p>
    </DefaultLayout>
  );
}
